import { isEmpty } from 'lodash-es'

export default function HTMLToPlainText(html: string) {
  if (isEmpty(html)) return ''
  const tempDivElement = document.createElement('div')
  tempDivElement.innerHTML = html
  return tempDivElement.textContent || tempDivElement.innerText || ''
}
